/*
このmain.jsには処理を書かず、ページまたは処理単位で個別にファイルを立てて、インポートするようにしてください

モジュールは要件次第では都度調整が必要によります
各importリンクはコメントアウトを外してAlt+クリックで直接そのファイルを開きます（VSCodeの場合）
*/

// アニメーション
// import './module/animation/_inAnimation.js' // 画面に入った要素のアニメーション
// import './module/animation/_inCount.js' // 画面に入った数値のカウントアップ演出

// フォーム
// import './module/form/_validation.js' // バリデーション処理
// import './module/form/_zipAddress.js' // 郵便番号から住所検索
// import './module/form/_datePicker.js' // 日付入力
// import './module/form/_browserBackReplace.js' // 確認画面等のブラウザバック操作を戻るボタン押下に差し替え

// UI
import './module/ui/_hashScroll.js' // アンカーリンクスクロール　デフォルト有効
import './module/ui/_spMenuToggle.js' // SPメニュー開閉　デフォルト有効
import './module/ui/_modal.js' // モーダル
// import './module/ui/_selectJump.js' // セレクトボックスによるページ遷移

// イベント
// import './module/event/_hoverSync.js' // マウスホバー状態の同期
// import './module/event/_scrollToggle.js' // スクロール量を基準にクラスを着脱する
// import './module/event/_destroyParent.js' // .js-destroyParentを押すと親の.js-destroyParent-frameを消す

// 動画
// import './module/video/_youtube.js' // YouTubeAPI

// ページ関連
import './_top.js'
import './_works.js'
import './_interview.js'
// import './_hoge.js'

/*
※ファイルを横断して関数を使いたい場合
windowオブジェクトに関数を格納することで使用できます

window.hogeFunction = function(fuga){
// 処理
}

// 呼び出し
window.hogeFunction(1111)
*/

//   ####  ######   #####    ####  ##  ##
//  ##       ##    ##   ##  ##     ## ##
//   ###     ##    ##   ##  ##     ####
//     ##    ##    ##   ##  ##     ## ##
//  ####     ##     #####    ####  ##  ##
// コードストック

// tUrl等のグローバル変数を宣言する。コメントアウト部分も含めて記述する
//  「/* global tUrl */」でWPのfooter.phpで宣言しているtUrlが使える
/* global  */

// jQuery　ライブラリが依存している場合を除いて非推奨
// import $ from 'jquery'

/*
Swiper使用時のインポート文

import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言

// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,
*/

/*
#### ##    ## ########          #######  ########   ######
 ##  ####  ##    ##            ##     ## ##     ## ##
 ##  ## ## ##    ##    ####### ##     ## ########   ######
 ##  ##  ####    ##            ##     ## ##     ##       ##
#### ##    ##    ##             #######  ########   ######
*/
// 画面に入った監視対象に.activeを付加
// Intersection Observer
window.intObs = function (rootMargin) {
  if (!document.getElementsByClassName('js-in')[0]) {
    return
  }
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '-20%', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-in')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const entryItem = entry.target
        entryItem.classList.add('animated')
        observer.unobserve(entryItem) // 監視対象から外す
      }
    }
  }
}

if (!document.getElementById('page-top')) {
  window.intObs('-10% 0px')
} else {
  window.intObs('-50% 0px')
}

/*
 ######   ######          ##    ##    ###    ##     ##
##       ##               ####  ##  ##   ##  ##     ##
 ######  ##       ####### ## ## ## ##     ## ##     ##
      ## ##               ##  #### #########  ##   ##
 ######   ######          ##    ## ##     ##    ###

ターゲットが走査線に入ったら連動する要素にクラスを当てる
Intersection Observer APIを使用

<a href="#hoge" class="js-scrollNav js-scrollNav--hoge"></a>
<section id="hoge" class="js-scrollNav-trigger" data-nav-target="hoge">
  section#hogeが画面に入ったらjs-scrollNav--hogeにクラスを当てる
</section>
*/

if (document.getElementsByClassName('js-scrollNav')[0]) {
  scrollNav()
}
function scrollNav() {
  const navItems = document.getElementsByClassName('js-scrollNav')
  const intObsOption = {
    rootMargin: '-50% 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(scrollNavCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-scrollNav-trigger')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function scrollNavCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      // 接触アイテムを発見
      if (entry.isIntersecting) {
        // 全ての.activeを外す
        for (let index = 0; index < navItems.length; index++) {
          navItems[index].classList.remove('current')
        }
        const entryItem = entry.target
        const target = entryItem.dataset.navTarget // 制御対象名を取得

        // 対象アイテムをアクティブにする
        const targetItems = document.getElementsByClassName('js-scrollNav--' + target)
        for (let index = 0; index < targetItems.length; index++) {
          const targetItem = targetItems[index]
          targetItem.classList.add('current')
        }
        break // 以降の判定は飛ばす
      }
    }
  }
}

/*
js-sidebar-toggleをクリックするとp-sidebar-itemsを表示/非表示
*/
if (document.getElementsByClassName('js-sidebar-toggle')[0]) {
  sidebarToggle()
}
function sidebarToggle() {
  const toggleBtn = document.getElementsByClassName('js-sidebar-toggle')[0]
  const sidebarItems = document.getElementsByClassName('p-sidebar-items')[0]

  if (!toggleBtn || !sidebarItems) {
    return
  }

  // デフォルトで非表示にする
  sidebarItems.style.display = 'none'

  // トグルボタンにクリックイベントを追加
  toggleBtn.addEventListener('click', function () {
    if (sidebarItems.style.display === 'none') {
      sidebarItems.style.display = 'flex'
      sidebarItems.classList.add('active')
      this.classList.add('active')
    } else {
      sidebarItems.style.display = 'none'
      sidebarItems.classList.remove('active')
      this.classList.remove('active')
    }
  })

  // p-sidebar--itemをクリックしたときにサイドバーを非表示にする
  const sidebarItemsList = document.getElementsByClassName('p-sidebar--item')
  for (let index = 0; index < sidebarItemsList.length; index++) {
    const sidebarItem = sidebarItemsList[index]
    sidebarItem.addEventListener('click', function () {
      sidebarItems.style.display = 'none'
      toggleBtn.classList.remove('active')
    })
  }
}
